import { Box } from "../../box";
import { cloneElement, forwardRef, useMemo } from "react";
import { cssModule, isNil, isString, mergeProps, normalizeSize, slot, useSlots } from "../../shared";
import { useResponsiveValue } from "../../styling";
import { Text } from "../../typography";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "section";
export function InnerCard({
  as = DefaultElement,
  children,
  fluid,
  forwardedRef,
  orientation = "vertical",
  size,
  ...rest
}) {
  var _header$props, _header$props2;

  const fluidValue = useResponsiveValue(fluid);
  const orientationValue = useResponsiveValue(orientation);
  const sizeValue = useResponsiveValue(size);
  const {
    button,
    "button-group": buttonGroup,
    content,
    header,
    heading,
    illustration,
    image
  } = useSlots(children, useMemo(() => ({
    _: {
      required: ["heading", "content"]
    },
    button: {
      className: "o-ui-card-button"
    },
    "button-group": {
      className: "o-ui-card-button-group"
    },
    content: {
      as: Text,
      className: "o-ui-card-content"
    },
    header: {
      className: "o-ui-card-header"
    },
    heading: {
      as: "span",
      className: "o-ui-card-heading",
      size: "xs"
    },
    illustration: {
      className: "o-ui-card-illustration",
      orientation: orientationValue === "horizontal" ? "vertical" : "horizontal"
    },
    image: null
  }), [orientationValue]));
  const headerMarkup = isString(header === null || header === void 0 ? void 0 : (_header$props = header.props) === null || _header$props === void 0 ? void 0 : _header$props.children) ? /*#__PURE__*/cloneElement(header, {
    children: /*#__PURE__*/_jsx(Text, {
      children: header === null || header === void 0 ? void 0 : (_header$props2 = header.props) === null || _header$props2 === void 0 ? void 0 : _header$props2.children
    })
  }) : header;

  const imageMarkup = image && /*#__PURE__*/_jsx(Box, {
    className: "o-ui-card-image",
    children: image
  });

  const headerSectionMarkup = /*#__PURE__*/_jsxs(Box, {
    className: "o-ui-card-header-section",
    children: [heading, headerMarkup]
  });

  const footerSectionMarkup = (!isNil(button) || !isNil(buttonGroup)) && /*#__PURE__*/_jsxs(Box, {
    className: "o-ui-card-footer-section",
    children: [button, buttonGroup]
  });

  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-card", orientationValue, !fluidValue && normalizeSize(sizeValue), fluidValue && "fluid"),
      ref: forwardedRef
    }),
    children: [imageMarkup, illustration, /*#__PURE__*/_jsxs(Box, {
      className: "o-ui-card-aside",
      children: [headerSectionMarkup, content, footerSectionMarkup]
    })]
  });
}
InnerCard.defaultElement = DefaultElement;
export const Card = slot("card", /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerCard, { ...props,
  forwardedRef: ref
})));